import { localisedValue } from "utils"

export function wealthPipelineStagesTransformer(data) {
  const rows = Array.isArray(data) ? data : []

  return rows.reduce(
    (acc, stage) => {
      const stageName = localisedValue({ object: stage, key: "name" })

      acc.flattenedStagesIds[stage?.key] = stage?.id

      const children =
        stage?.subStages?.map(child => {
          const childName = localisedValue({ object: child, key: "name" })

          acc.flattenedStagesIds[child?.key] = child?.id

          return {
            value: child?.id,
            key: child?.key,
            label: childName,
            title: childName,
          }
        }) || []

      acc.stages.push({
        value: stage?.id,
        key: stage?.key,
        label: stageName,
        title: stageName,
        children,
      })

      if (stage?.id != null) {
        acc.childrenByStageId[stage.id] = children
      }

      return acc
    },
    {
      stages: [],
      childrenByStageId: {},
      flattenedStagesIds: {},
    }
  )
}
